/** Set on the root element of every rendered ConsentBanner instance. */
export const CONSENT_BANNER_ATTRIBUTE = 'data-consent-banner'

/**
 * Height in px of the consent banner currently on screen, or 0 when none is.
 *
 * The layout renders one banner for desktop and one for mobile, and hides the
 * other with CSS, so visibility is read from the DOM instead of storage: a
 * banner that is not rendered, hidden by its breakpoint or dismissed has no
 * client rects or reports `aria-hidden="true"`.
 */
export const getVisibleConsentBannerHeight = () => {
  if (typeof document === 'undefined') return 0

  const banners = document.querySelectorAll(`[${CONSENT_BANNER_ATTRIBUTE}]`)

  for (const banner of banners) {
    if (
      banner.getAttribute('aria-hidden') !== 'true' &&
      banner.getClientRects().length > 0
    ) {
      return banner.getBoundingClientRect().height
    }
  }

  return 0
}
